// extracted by mini-css-extract-plugin
export default {"cls1":"useImageAttachment-cls1_ZDW","cls2":"useImageAttachment-cls2_zFG useImageAttachment-cls1_ZDW"};